import ActorService from '@/common/api/actor'
import {
  GET_ACTOR,
  GET_ACTOR_BY_SETTING,
  GET_ACTOR_BY_SEND_MESSAGE
} from './actions'
import {
  FETCH_ACTOR
} from './mutations'

const state = {
  actor: {}
}

const getters = {
  actor (state) {
    return state.actor
  }
}

const actions = {
  [GET_ACTOR] (context, { id, params = {} }) {
    return new Promise((resolve, reject) => {
      ActorService.get(id, params)
        .then(({ data }) => {
          context.commit(FETCH_ACTOR, data)
          resolve(data)
        })
        .catch(error => {
          context.commit(FETCH_ACTOR, null)
          reject(error)
        })
    })
  },
  [GET_ACTOR_BY_SETTING] (context, { id, settingId, params = {} }) {
    return new Promise((resolve, reject) => {
      ActorService.getBySetting(id, settingId, params)
        .then(({ data }) => {
          context.commit(FETCH_ACTOR, data)
          resolve(data)
        })
        .catch(error => {
          context.commit(FETCH_ACTOR, null)
          reject(error)
        })
    })
  },
  [GET_ACTOR_BY_SEND_MESSAGE] (context, { id, params = {} }) {
    return new Promise((resolve, reject) => {
      ActorService.getBySendMessage(id, params)
        .then(({ data }) => {
          context.commit(FETCH_ACTOR, data)
          resolve(data)
        })
        .catch(error => {
          context.commit(FETCH_ACTOR, null)
          reject(error)
        })
    })
  }
}

const mutations = {
  [FETCH_ACTOR] (state, data) {
    state.actor = data
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
